module.exports = __webpack_public_path__ + "media/images/landing/flags/um-05615112706e0396ff8c91eb9b6c05f2.svg";